import styled from "styled-components";

import { TruncatedTextWithTooltip } from "@similarweb/ui-components";
import { Flex, Text } from "@similarweb/ui-components/foundations";

import { ICON_XY } from "app/pages/sales-intelligence/common-components/table-cells/components/ExpandCell/styles";

// Keep at least ~4 characters of the main domain visible before the ellipsis.
const MIN_VISIBLE_DOMAIN_WIDTH = "5ch";

// Align single-domain text with the expandable rows' main domain:
// expand icon (ICON_XY) + 4px icon margin + 4px row gap.
const SINGLE_DOMAIN_INDENT = ICON_XY + 8;

export const StyledDomain = styled(TruncatedTextWithTooltip)`
    min-width: ${MIN_VISIBLE_DOMAIN_WIDTH};
`;

export const StyledCount = styled(Text)`
    flex-shrink: 0;
    white-space: nowrap;
`;

export const SingleDomainWrapper = styled(Flex)`
    min-width: 0;
    padding-left: ${SINGLE_DOMAIN_INDENT}px;
`;
